import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Goal} from '../../models/goal';

@Injectable({
  providedIn: 'root'
})
export class GoalService extends AbstractModelService<Goal> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/goal', Goal);
  }
}
